import get from 'lodash/get';
import { cappedMemoize } from '../../../../../utils/memoize';

const listWildcard = '[*]';

interface Params {
  data: Record<string, unknown>;
  path: string;
  name: string;
  lookupMap: Record<string, unknown>;
}

const getPathInfo = cappedMemoize((path: string) => {
  const lastDotIndex = path.lastIndexOf('.');
  const valuePath = path.replace(listWildcard, '');

  if (lastDotIndex === -1) {
    return { parentPath: undefined, valuePath };
  }

  return { parentPath: path.slice(0, lastDotIndex), valuePath };
});

export const mutateDataWithLookupReferences = (params: Params) => {
  const { data, path, name, lookupMap } = params;

  const { parentPath, valuePath } = getPathInfo(path);
  const parentObject = (parentPath ? get(data, parentPath) : data) as Record<string, unknown>;

  // if value is list - then path will be like a.b.c[*], so we need to remove [*] from path
  // tbd - can there be nested lists? to be handled as per use case
  const value = get(data, valuePath) as undefined | string | string[];

  if (typeof parentObject !== 'object' || !value) {
    return;
  }

  let lookupValue: unknown;

  if (Array.isArray(value)) {
    lookupValue = value.map((item) => lookupMap[item] ?? item);
  } else {
    lookupValue = lookupMap[value];
  }

  if (lookupValue) {
    parentObject[name] = lookupValue;
  }
};
